<template>
    <div>
        <nav class="navbar" id="navbar">
            <div class="container relative flex flex-wrap items-center justify-between">
                <a class="navbar-brand md:me-8" href="/">
                    <span class="inline-block dark:hidden">
                        <img src="../assets/images/ummonlab.svg" width="150px" class="l-dark" alt="">
                        <img src="../assets/images/ummonlab-dark.svg" width="150px" class="l-light" alt="">
                    </span>
                    <img src="../assets/images/ummonlab-dark.svg" width="150px" class="hidden dark:inline-block" alt="">
                </a>

                <div class="nav-icons flex items-center lg_992:order-2 ms-auto md:ms-8">
                    <!-- Navbar Button -->
                    <ul class="list-none menu-social mb-0">
                        <li class="inline">
                            <a href="https://doc.ummonlab.com" class="h-8 px-4 text-[12px] tracking-wider inline-flex items-center justify-center font-medium rounded-md bg-teal-500 text-white uppercase">{{ $t('navlight.11') }}</a>
                        </li>
                    </ul>
                    <!-- Navbar Collapse Manu Button -->
                    <button data-collapse="menu-collapse" type="button" class="collapse-btn inline-flex items-center ms-2 text-dark dark:text-white lg_992:hidden" aria-controls="menu-collapse" aria-expanded="false" @click="handler" >
                        <span class="sr-only">Navigation Menu</span>
                        <i class="mdi mdi-menu text-[24px]"></i>
                    </button>
                </div>

                <!-- Navbar Manu -->
          
                <div class="navigation lg_992:order-1 lg_992:flex ms-auto" :class="{hidden: !toggle}" id="menu-collapse">
                    <ul class="navbar-nav nav-light sidebar-nav" id="navbar-navlist">
                        <li class="nav-item ms-0 active home">
                            <a class="nav-link" href="#home">{{ $t('navlight.1') }}</a>
                        </li>
                        <li class="nav-item ms-0 about">
                            <a class="nav-link" href="#about">{{ $t('navlight.2') }}</a>
                        </li>
                        <li class="nav-item ms-0 services">
                            <a class="nav-link" href="#services">{{ $t('navlight.3') }}</a>
                        </li>
                        <li class="nav-item ms-0 engine">
                            <a class="nav-link" href="#engine">{{ $t('navlight.4') }}</a>
                        </li>
                        <li class="nav-item ms-0 review">
                            <a class="nav-link" href="#review">{{ $t('navlight.5') }}</a>
                        </li>
                        <li class="nav-item ms-0 contact">
                            <a class="nav-link" href="#contact">{{ $t('navlight.6') }}</a>
                        </li>

                        <li class="nav-item ms-0 language relative">
                            <button class="nav-link flex items-center" type="button" @click="toggleLanguageMenu = !toggleLanguageMenu">
                                <span>{{ $t('navlight.7') }}</span> <i class="mdi mdi-chevron-down ms-1"></i>
                            </button>
                            <ul v-show="toggleLanguageMenu" 
                                class="absolute left-0 border shadow-md rounded-md mt-2 z-10 w-40 overflow-hidden transition-colors duration-300"
                                :class="{
                                    'bg-white text-black border-gray-300 dark:bg-gray-900 dark:text-white dark:border-gray-700': !isWhiteAtTop,
                                    'bg-gray-900 text-white border-gray-700': isWhiteAtTop
                                }">
                                <li class="nav-item ms-0 english" @click.prevent="changeLanguage('en')">
                                    <a class="nav-link block px-4 py-2 first:rounded-t-md"
                                        :class="{
                                            'hover:bg-gray-800 hover:text-white': isWhiteAtTop,
                                            'hover:bg-gray-100 dark:hover:bg-gray-800': !isWhiteAtTop
                                        }">
                                        {{ $t('navlight.8') }}
                                    </a>
                                </li>
                                <li class="nav-item ms-0 polish" @click.prevent="changeLanguage('pl')">
                                    <a class="nav-link block px-4 py-2"
                                        :class="{
                                            'hover:bg-gray-800 hover:text-white': isWhiteAtTop,
                                            'hover:bg-gray-100 dark:hover:bg-gray-800': !isWhiteAtTop
                                        }">
                                        {{ $t('navlight.9') }}
                                    </a>
                                </li>
                                <li class="nav-item ms-0 deutsch" @click.prevent="changeLanguage('de')">
                                    <a class="nav-link block px-4 py-2 first:rounded-b-md"
                                        :class="{
                                            'hover:bg-gray-800 hover:text-white': isWhiteAtTop,
                                            'hover:bg-gray-100 dark:hover:bg-gray-800': !isWhiteAtTop
                                        }">
                                        {{ $t('navlight.10') }}
                                    </a>
                                </li>
                            </ul>

                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>

// This may come from a CMS, markdown file, etc.


export default {
    components:{
        
    },
    data() {
        return { 
            toggle:false,
            scroll:true,
            current : "",
            sectionTop:null,
            toggleLanguageMenu: false, // Control visibility of the language dropdown
            isWhiteAtTop: false,
            observer: null, // Przechowywanie obserwatora
         }
    },
    created () {
        window.addEventListener("click", this.handleClickOutside);
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('scroll', this.onscroll);

        this.updateThemeState(); // Sprawdzenie motywu na starcie

        this.observer = new MutationObserver(() => {
        this.updateThemeState();
    });

    this.observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    },
    mounted() {
        this.sections = document.querySelectorAll("section");
        this.navLi = document.querySelectorAll("nav .container .navigation ul li");
    },

    unmounted () {
        window.removeEventListener("click", this.handleClickOutside);
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('scroll', this.onscroll);

        if (this.observer) {
            this.observer.disconnect(); // Usunięcie obserwatora
        }
    },

    methods: {
    handler: function() {
      this.toggle = !this.toggle;
    },

    updateThemeState() {
    let isDarkMode = document.documentElement.classList.contains("dark");
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    
    this.isWhiteAtTop = !isDarkMode && scrollTop < 50;

    const navbar = document.getElementById("navbar");
    if (navbar) { // Sprawdzamy, czy element istnieje
        if (scrollTop >= 50) {
            navbar.classList.add("is-sticky");
        } else {
            navbar.classList.remove("is-sticky");
        }
    }
},

    changeLanguage(lang) {
        this.$i18n.locale = lang;

        this.toggleLanguageMenu = false; // Zamknięcie menu
    },

    handleScroll() {
        this.toggleLanguageMenu = false; // Zamknięcie menu językowego
        this.updateThemeState(); // Aktualizacja motywu i klasy `is-sticky`
    },

    handleClickOutside(event) {
        const languageMenu = document.querySelector(".language");
        if (languageMenu && !languageMenu.contains(event.target)) {
            this.toggleLanguageMenu = false;
        }
    },

    onscroll () {
        document.querySelectorAll("section").forEach((section) => {
            this.sectionTop = section.offsetTop;
            if (window.scrollY >= this.sectionTop - 60) {
            this.current = section.getAttribute("id"); 
            }
        });
        document.querySelectorAll("nav .container .navigation ul li").forEach((li) => {
            if (li.classList.contains(this.current)) {
                li.classList.add("active");
            }else{
                li.classList.remove("active");
            }
        });
    }
  },
}
</script>